import { useEffect } from 'react';
import AgrupacionArticulosForm from '../../components/agrupaciones-articulos/AgrupacionArticulosForm';
import {
  useAgrupacionArticulosStore,
  type RegistrarAgrupacionArticulos
} from '../../stores/agrupaciones-articulos/agrupaciones-articulos.store';

const AgregarAgrupacionArticulos = () => {
  const { current: agrupacion, nuevo, registrar } = useAgrupacionArticulosStore((state) => state);

  useEffect(() => {
    nuevo();
  }, [nuevo]);

  const handleSave = (values: RegistrarAgrupacionArticulos) => {
    return registrar(values);
  };

  return <AgrupacionArticulosForm esAgregar={true} agrupacion={agrupacion} onSave={handleSave} />;
};

export default AgregarAgrupacionArticulos;
